import { CobranzasAxios, COMPANY } from './config'

export const postContracts = async (data) => {
  const res = await CobranzasAxios.post(`/contract/${COMPANY}`, data)
  return res.data
}

export const getContracts = async () => {
  const res = await CobranzasAxios.get(`/contract/${COMPANY}`)
  return res.data
}

export const getContract = async (contractId) => {
  const res = await CobranzasAxios.get(`/contract/status/${contractId}`)
  return res.data
}

export const getContractsToSelect = async () => {
  const res = await CobranzasAxios.get(`/contract/select/${COMPANY}`)
  return res.data
}

export const getClientContracts = async (clientId) => {
  const res = await CobranzasAxios.get(`/contract/${clientId}/${COMPANY}`)
  return res.data
}

export const putContracts = async (data, id) => {
  const res = await CobranzasAxios.put(`/contract/${id}`, data)
  return res.data
}

export const generateWork = async (id, data) => {
  const res = await CobranzasAxios.put(`/contract/change-status/${id}`, data)
  return res.data
}

export const exportContracts = async (data) => {
  const res = await CobranzasAxios.post(`/contract/export/${COMPANY}`, data)
  return res.data
}

export const updateNumTvs = async (id, data) => {
  const res = await CobranzasAxios.put(`/contract/numTvs/${id}`, data)
  return res.data
}

export const validateContracts = async () => {
  const res = await CobranzasAxios.get(`/contract/verify/${COMPANY}`)
  return res.data
}

export const deleteContract = async (contractId) => {
  const res = await CobranzasAxios.delete(`/contract/${contractId}`)
  return res.data
}
